import React from 'react';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import HorizontalBarChart from '../../../../components/admin/reports/charts/HorizontalBarChart';
import {moneyMask} from '../../../../utils/utils';

export default function ProductsChart({dateFrom, dateTo}) {
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_ECOMMERCE_PRODUCTS,
        params: {date_from: dateFrom, date_to: dateTo},
        dataDefault: {},
    });
    const distribution = [...(data?.distribution || [])].sort((a, b) => b.revenue - a.revenue);

    return (
        <ReportChartCard title="Vendas por Categoria de Produto" loading={isLoading} isEmpty={!distribution.length}>
            <HorizontalBarChart
                data={distribution}
                dataKey="revenue"
                nameKey="category"
                valueFormatter={(v) => `R$ ${moneyMask(v)}`}
                tooltipFields={[
                    {key: 'revenue', label: 'Receita', formatter: (v) => `R$ ${moneyMask(v)}`},
                    {key: 'qty', label: 'Quantidade'},
                    {key: 'orders', label: 'Pedidos'},
                ]}
            />
        </ReportChartCard>
    );
}
